import './Footer.scss';

class Footer {

    constructor(node) {
        this.node = node;
    }

    init() {
      //console.log();
    }

}

JSModules['Footer'] = Footer;
export default Footer;
